jQuery(function($){

    function archiveUrl() {
        return window.location.href.replace(/\/page\/\d+\/?/, '/').split('?')[0];
    }

    function pushFilterUrl(baseUrl, params) {
        var query = Object.entries(params)
            .filter(function(e) { return e[1]; })
            .map(function(e) { return encodeURIComponent(e[0]) + '=' + encodeURIComponent(e[1]); })
            .join('&');
        history.pushState(null, '', baseUrl + (query ? '?' + query : ''));
    }

    // Activity filter
    $('#filter').on('click', function () {
        var baseUrl      = archiveUrl();
        var price        = $('#priceRange').val();
        var postType      = $('#postType').val();
        var productGroup  = $('#productGroup').val();
        var postsPerPage  = $('#postsPerPage').val();

        var persons = [];
        $('input[name="persons[]"]:checked').each(function(){
            persons.push($(this).val());
        });

        var types = [];
        $('input[name="activity_type[]"]:checked').each(function(){
            types.push($(this).val());
        });

        var data = {
            action:       'filter_activities',
            pageNo:       1,
            postType:     postType,
            productGroup: productGroup,
            postsPerPage: postsPerPage,
            price:        price,
            persons:      persons.join(','),
            types:        types.join(','),
            pageBase:     baseUrl,
        };

        $.post(ocnAjax.url, data, function(response) {
            $('.activity_row').html(response.html);
            $('.js-pagination').html(response.pagination);
            pushFilterUrl(baseUrl, { price: price, persons: persons.join(','), types: types.join(',') });
        }, 'json');

        return false;
    });

    // Events filter
    $('#event_filter').on('click', function () {
        var baseUrl  = archiveUrl();
        var price    = $('#priceRange').val();

        var persons = [];
        $('input[name="persons[]"]:checked').each(function(){
            persons.push($(this).val());
        });

        var event_types = [];
        $('input[name="event_types[]"]:checked').each(function(){
            event_types.push($(this).val());
        });

        var data = {
            action:       'filter_events',
            pageNo:       1,
            price:        price,
            persons:      persons.join(','),
            event_types: event_types.join(','),
            pageBase:     baseUrl,
        };

        $.post(ocnAjax.url, data, function(response) {
            $('.events_row').html(response.html);
            $('.js-pagination').html(response.pagination);
            pushFilterUrl(baseUrl, { price: price, persons: persons.join(','), event_types: event_types.join(',') });
        }, 'json');

        return false;
    });

});
